export default "__VITE_ASSET__DvwgbRoe__"